import * as yup from 'yup';

import { strings } from '../constants/strings';

import tenantConstants from '@constants';
import { t } from 'i18next';
import { isValidPhoneNumber } from 'react-phone-number-input';

export const phoneValidationYup = (isRequired = true, isMulti, requiredMsg) => {
  if (tenantConstants.COUNTRY_CODE === 'PK') {
    if (!!isMulti) {
      return yup.array().of(
        yup
          .string()
          .required(requiredMsg ? requiredMsg : t(strings.vm.phone))
          .test('format', t(strings.im.phone), (value) => {
            return isValidPhoneNumber(value ? value : '-');
          }),
      );
    } else {
      return isRequired
        ? yup
            .string()
            .required(requiredMsg ? requiredMsg : t('Please enter your number'))
            .test('format', t(strings.im.phone), (value) => {
              return isValidPhoneNumber(value ? value : '-');
            })
        : yup
            .string()
            .test('format', t(strings.im.phone), (value) => {
              return value ? isValidPhoneNumber(value ? value : '-') : true;
            })
            .nullable();
    }
  } else if (tenantConstants.COUNTRY_CODE === 'SA') {
    if (!!isMulti) {
      return yup.array().of(
        yup
          .string()
          .required(requiredMsg ? requiredMsg : t(strings.vm.phone))
          .test('format', t(strings.im.phone), (value) => {
            if (!value) return true;
            return tenantConstants.PHONE_REGEX ? tenantConstants.PHONE_REGEX.test(value) : true;
          }),
      );
    } else {
      return isRequired
        ? yup
            .string()
            .required(requiredMsg ? requiredMsg : t('Please enter your number'))
            .test('format', t(strings.im.phone), (value) => {
              if (!value) return true;
              return tenantConstants.PHONE_REGEX ? tenantConstants.PHONE_REGEX.test(value) : true;
            })
        : yup
            .string()
            .test('format', t(strings.im.phone), (value) => {
              if (!value) return true;
              return tenantConstants.PHONE_REGEX ? tenantConstants.PHONE_REGEX.test(value) : true;
            })
            .nullable();
    }
  }
};

export const websiteValidation = (
  websiteRegex = /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}(\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)|(\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)\.[a-zA-Z0-9()]{1,6}\b))$/,
) => {
  return yup
    .string()
    .test('', t(strings.enter_valid_website), function (value) {
      if (!value) return true;
      const isValidWebsite = websiteRegex.test(value);
      if (!isValidWebsite) {
        return false;
      }
      return true;
    })
    .nullable();
};

export const emailValidationYup = (emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/) => {
  return yup
    .string()
    .required(t('Email is required'))
    .test('', strings.enter_valid_email, function (value) {
      const isValidEmail = emailRegex.test(value);
      if (!isValidEmail) {
        return false;
      }
      return true;
    });
};

export const stringValidationYup = (requiredMsg, regex = '', invalidMsg = 'invalid msg hasnt been added') => {
  if (requiredMsg) {
    if (regex && requiredMsg) return yup.string().required(requiredMsg).matches(regex, invalidMsg).nullable();
    return yup.string().required(requiredMsg).nullable();
  } else
    return yup.string().test('', invalidMsg, (value) => {
      if (!value) return true;
      return regex ? regex.test(value) : true;
    });
};

export const cnicValidationYup = () => {
  const pattern = /^\d{5}-\d{7}-\d{1}$/;
  return yup
    .string()
    .required(t('CNIC is required'))
    .test('cnic-format', t('Enter a valid CNIC (XXXXX-XXXXXXX-X)'), (value) => {
      if (!value) return false;
      return pattern.test(value);
    });
};

export const landlineValidationYup = (isRequired = false) => {
  const landlinePattern = /^\+92\s\d{2}\s\d{7}$/;

  if (isRequired) {
    return yup
      .string()
      .required(t('Please enter landline number'))
      .test('landline-format', t('Landline must be in format: +92 XX YYYYYYY'), (value) => {
        if (!value) return false;
        return landlinePattern.test(value);
      });
  } else {
    return yup
      .string()
      .test('landline-format', t('Landline must be in format: +92 XX YYYYYYY'), (value) => {
        if (!value) return true;
        return landlinePattern.test(value);
      })
      .nullable();
  }
};
